import { useEffect, useState } from 'react';
import { Header, Icon, Message } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import UserDetails from './userDetails';
import AssignUserThirdScreen from '../AssignUserThirdScreen';
import agent from '../../../app/api/agent';
import { useStore } from '../../../app/stores/store';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import './styles.css';

function AssetScan({ isShowAssetProp }: { isShowAssetProp: boolean }) {
  const { userStore } = useStore();

  const history = useNavigate();

  const { id } = useParams<{ id: string }>();

  const [userDetails, setUserDetails] = useState({
    name: '',
    image: '',
  });
  const [assetDetails, setAssetDetails] = useState({
    id: '',
    name: '',
    image: '',
    receiver: '',
    currentTask: '',
    currentSubtask: '',
    workflowStatus: '',
    receiverStatus: '',
    handovertype: '',
    removeUserId: '',
  });
  const [isShowAsset, setIsShowAsset] = useState(isShowAssetProp);
  const [error, setError] = useState({
    camera: false,
    message: '',
  });
  const [historyDetails, setHistoryDetails] = useState({});

  useEffect(() => {
    let timer = setTimeout(() => {
      setError({
        ...error,
        message: '',
      });
    }, 3000);
    // eslint-disable-next-line
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [error.message]);

  const submitHandler = (historyDetails: any) => {
    setIsShowAsset(true);
    setHistoryDetails(historyDetails);
  };

  const handoverHandler = async () => {
    try {
      let payload = {
        id: assetDetails.id,
        receiver: userDetails.name,
        receiver_Status:
          assetDetails.handovertype.toLocaleLowerCase() === 'handover'
            ? 'Handed Over'
            : 'Returned',
        issuer: userStore.user?.displayName || '',
        movementdate: new Date().toISOString(),
      };

      let assignResult: any;

      if (assetDetails.handovertype.toLocaleLowerCase() === 'return') {
        assignResult = await agent.Activities.attenddelete(
          assetDetails.id,
          assetDetails.removeUserId || id || '',
        );
      } else {
        assignResult = await agent.Activities.attend(assetDetails.id, id || '');
      }

      if (assignResult) {
        let result = await agent.Activities.newHandOverStatus(payload);
        if (result?.data) {
          const HistoryArr: any = {
            id: assetDetails.id,
            itemHistory: [historyDetails],
          };
          await agent.Activities.onlyHistory(assetDetails.id, HistoryArr);
          toast.success(
            assetDetails.handovertype.toLocaleLowerCase() === 'return'
              ? 'Successfully returned'
              : 'Successfully assigned',
          );
          history('/assignuser');
        }
      }
    } catch (err: any) {
      setError({
        ...error,
        message: err || 'Oops! Something went wrong',
      });
    }
  };

  return (
    <>
      {isShowAsset ? (
        <AssignUserThirdScreen
          assetDetails={assetDetails}
          handoverHandler={handoverHandler}
        />
      ) : (
        <div className="assign-asset-scan-wrapper">
          <Header as="h3">
            <Icon name="search" size="tiny" />
            <Header.Content>Scan Asset</Header.Content>
          </Header>
          {error.camera ? (
            <Message
              negative
              content="We're sorry we can't scan the asset without accessing the camera."
            />
          ) : (
            <UserDetails
              userDetails={userDetails}
              setUserDetails={setUserDetails}
              assetDetails={assetDetails}
              setAssetDetails={setAssetDetails}
              error={error}
              setError={setError}
              submitHandler={submitHandler}
            />
          )}
          {error.message && (
            <Message negative content={error.message}></Message>
          )}
          {/* {isSearching && (
        <Message icon>
          <Icon name="circle notched" loading />
          <Message.Content>
            We are fetching that content for you.
          </Message.Content>
        </Message>
      )} */}
        </div>
      )}
    </>
  );
}

export default observer(AssetScan);
